import { Injectable } from '@angular/core';

@Injectable()
export class TooltipDataSharedService {
  protected tooltipInstances: any = new Array();
  // private uniqueKey: number;
  generateUniqueKey(): number {
    return new Date().valueOf();
  }
  setData(options: any, key) {
    this.tooltipInstances[key] = options;
  }
  getData(key) {
    return this.tooltipInstances[key];
  }
  destroyData(key) {
    delete this.tooltipInstances[key];
  }
}
